import React, { useMemo, useState } from "react";
import "./Stepped.css";
import close from "../img/close.png";

const WORDS = [
  { id: "w1", text: "готовит" },
  { id: "w2", text: "работает" },
  { id: "w3", text: "читает" },
  { id: "w4", text: "спешит" },
  { id: "w5", text: "думает" },
];

const SENTENCES = [
  {
    id: "s1",
    textParts: ["Моя мама всегда ", " вкусный ужин для всей семьи."],
    answer: "готовит",
  },
  {
    id: "s2",
    textParts: ["Мой брат ", " в большой компании программистом."],
    answer: "работает",
  },
  {
    id: "s3",
    textParts: ["Она каждый вечер ", " интересные книги перед сном."],
    answer: "читает",
  },
  {
    id: "s4",
    textParts: ["Когда Антон опаздывает, он всегда ", " на работу."],
    answer: "спешит",
  },
  {
    id: "s5",
    textParts: ["Преподаватель ", " что этот экзамен будет сложным."],
    answer: "думает",
  },
];

const FILL_GAP_QUESTIONS = [
  {
    text: ["Я обычно пью ", " каждое утро."],
    answer: "кофе"
  },
  {
    text: ["Мой дедушка не может читать без своих ", "."],
    answer: "очков"
  },
  {
    text: ["Анна - ", " Сергея. Они поженились в прошлом году."],
    answer: "жена"
  },
  {
    text: ["Где моя ", "? Там мой телефон, деньги и ключи."],
    answer: "сумка"
  },
  {
    text: ["Я Павел. Очень приятно ", " с вами!"],
    answer: "познакомиться"
  },
];

const MATCH_HALVES_QUESTIONS = [
  { id: '1', left: 'На концерте было столько', right: 'народу, что все танцевали.' },
  { id: '2', left: 'Будь', right: 'осторожен с этой вазой! Она очень дорогая.' },
  { id: '3', left: 'Я думаю,', right: 'метро - самый быстрый способ передвигаться по городу.' },
  { id: '4', left: 'Максим хотел быть спортивным, поэтому решил ходить в', right: 'спортзал.' },
  { id: '5', left: 'Иногда богатые люди не счастливее', right: 'бедных.' },
];

const FILL_GAP_WITH_OPTIONS_QUESTIONS = [
  {
    parts: [
      "Дима часто опаздывает на занятия и никогда не ",
      { options: ["говорит", "говорю"], answer: "говорит" },
      ' "извините".'
    ]
  },
  {
    parts: [
      "Смотри! Твоя кошка ",
      { options: ["бежит", "бегает"], answer: "бежит" },
      " к тебе."
    ]
  },
  {
    parts: [
      "Катя, что ты ",
      { options: ["думаешь", "думаю"], answer: "думаешь" },
      " об этом?"
    ]
  },
  {
    parts: [
      "Хорошо, ты примерила 10 разных пальто. Тебе ",
      { options: ["нравится", "нравятся"], answer: "нравится" },
      " хоть одно из них?"
    ]
  },
  {
    parts: [
      "Моя девушка часто ",
      { options: ["пьет", "пью"], answer: "пьет" },
      " кофе перед сном. Это странно?"
    ]
  },
  {
    parts: [
      "Твоя собака такая смешная! Подожди, я ",
      { options: ["достаю", "достану"], answer: "достаю" },
      " телефон. Хочу сфотографировать."
    ]
  }
];

export default function Stepped() {
  const wordById = useMemo(
    () => WORDS.reduce((m, w) => ((m[w.id] = w.text), m), {}),
    []
  );

  const STORAGE_KEY = 'russianTestProgress';

  function saveProgress(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Failed to save progress:', e);
    }
  }

  function loadProgress() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      console.error('Failed to load progress:', e);
      return null;
    }
  }

  function clearProgress() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Failed to clear progress:', e);
    }
  }

  const savedProgress = loadProgress();
  const [bank, setBank] = useState(savedProgress?.bank || WORDS.map((w) => w.id));
  const [placed, setPlaced] = useState(savedProgress?.placed || Array(SENTENCES.length).fill(null));
  const [selectedWord, setSelectedWord] = useState(null);
  const [checked, setChecked] = useState(savedProgress?.checked || false);
  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  
  const [stage, setStage] = useState(savedProgress?.stage || 0);
  
  const [matchLeftOrder, setMatchLeftOrder] = useState(
    savedProgress?.matchLeftOrder || MATCH_HALVES_QUESTIONS.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchRightOrder, setMatchRightOrder] = useState(
    savedProgress?.matchRightOrder || MATCH_HALVES_QUESTIONS.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchPairs, setMatchPairs] = useState(savedProgress?.matchPairs || Array(MATCH_HALVES_QUESTIONS.length).fill(null));
  const [matchSelectedLeft, setMatchSelectedLeft] = useState(null);
  const [matchChecked, setMatchChecked] = useState(savedProgress?.matchChecked || false);

  const [gapAnswers, setGapAnswers] = useState(savedProgress?.gapAnswers || Array(FILL_GAP_QUESTIONS.length).fill(""));
  const [gapChecked, setGapChecked] = useState(savedProgress?.gapChecked || false);

  const [fgwoAnswers, setFgwoAnswers] = useState(savedProgress?.fgwoAnswers || Array(FILL_GAP_WITH_OPTIONS_QUESTIONS.length).fill(null).map((_, i) => {
    const n_opts = FILL_GAP_WITH_OPTIONS_QUESTIONS[i].parts.filter(p => typeof p === 'object').length;
    return Array(n_opts).fill('');
  }));
  const [fgwoChecked, setFgwoChecked] = useState(savedProgress?.fgwoChecked || false);
  const [showResults, setShowResults] = useState(false);

  React.useEffect(() => {
    const progressData = {
      stage,
      bank,
      placed,
      checked,
      matchLeftOrder,
      matchRightOrder,
      matchPairs,
      matchChecked,
      gapAnswers,
      gapChecked,
      fgwoAnswers,
      fgwoChecked,
    };
    saveProgress(progressData);
  }, [
    stage, bank, placed, checked, matchLeftOrder, matchRightOrder, matchPairs, matchChecked,
    gapAnswers, gapChecked, fgwoAnswers, fgwoChecked
  ]);

  function formatPhoneNumber(value) {
    const digits = value.replace(/\D/g, '');
    let formatted = '+7';
    
    if (digits.length > 1) {
      const firstThree = digits.slice(1, 4);
      if (firstThree.length > 0) {
        formatted += ' ' + firstThree;
      }
      
      if (digits.length > 4) {
        formatted += ' ' + digits.slice(4, 7);
      }
      
      if (digits.length > 7) {
        formatted += ' ' + digits.slice(7, 9);
      }
      
      if (digits.length > 9) {
        formatted += ' ' + digits.slice(9, 11);
      }
    }
    
    return formatted;
  }

  function validatePhoneNumber(phone) {
    const digits = phone.replace(/\D/g, '');
    
    if (digits.length !== 11) {
      return { valid: false, error: "Номер должен содержать 11 цифр" };
    }
    
    if (!digits.startsWith('7')) {
      return { valid: false, error: "Номер должен начинаться с +7" };
    }
    
    const operatorCode = parseInt(digits.slice(1, 4));
    if (operatorCode < 700 || operatorCode > 800) {
      return { valid: false, error: "Код оператора должен быть в диапазоне 700-800" };
    }
    
    return { valid: true, error: null };
  }

  function handlePhoneNumberChange(e) {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
    setSubmitError("");
  }

  function handleFinalComplete() {
    setShowModal(true);
  }

  function handleRestartTest() {
    setShowResults(false);
    clearProgress();
    setStage(0);
    setBank(WORDS.map((w) => w.id));
    setPlaced(Array(SENTENCES.length).fill(null));
    setSelectedWord(null);
    setChecked(false);
    setGapAnswers(Array(FILL_GAP_QUESTIONS.length).fill(""));
    setGapChecked(false);
    setMatchPairs(Array(MATCH_HALVES_QUESTIONS.length).fill(null));
    setMatchChecked(false);
    setFgwoAnswers(FILL_GAP_WITH_OPTIONS_QUESTIONS.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked(false);
    setPhoneNumber("");
  }

  async function handlePhoneSubmit(e) {
    e.preventDefault();
    
    const validation = validatePhoneNumber(phoneNumber);
    if (!validation.valid) {
      setSubmitError(validation.error);
      return;
    }
    
    setIsSubmitting(true);
    setSubmitError("");
    
    try {
      const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbzIcihp7wXijkCbrgK6R_9l-BJVlmReWJXQVN3Gh5LsoSHem8U3s4P7309MiCxFAwoc2Q/exec';
      
      const response = await fetch(GOOGLE_SHEETS_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          phone: phoneNumber,
          result: `${TOTAL_CORRECT}/${TOTAL_MAX}`,
          accuracy: `${ACCURACY}%`,
          level: RUSSIAN_LEVEL,
        })
      });
      
      clearProgress();
      setShowModal(false);
      setShowResults(true);
      
    } catch (error) {
      console.error('Ошибка при отправке:', error);
      setSubmitError("Не удалось отправить заявку. Пожалуйста, попробуйте снова.");
    } finally {
      setIsSubmitting(false);
    }
  }

  function handleModalClose() {
    if (!isSubmitting) {
      setShowModal(false);
      setPhoneNumber("");
      setSubmitError("");
    }
  }

  const score = placed.reduce((acc, wid, i) => {
    if (!wid) return acc;
    return acc + (wordById[wid] === SENTENCES[i].answer ? 1 : 0);
  }, 0);

  const gapScore = gapAnswers.reduce(
    (acc, ans, i) => acc + (ans.trim().toLowerCase() === FILL_GAP_QUESTIONS[i].answer ? 1 : 0),
    0
  );

  const matchScore = matchPairs.reduce(
    (acc, rid, lidx) =>
      acc + (rid !== null && matchLeftOrder[lidx] === matchRightOrder[rid] ? 1 : 0),
    0
  );

  const fgwoScore = fgwoAnswers.reduce((acc, arr, qIdx) => {
    const opts = FILL_GAP_WITH_OPTIONS_QUESTIONS[qIdx].parts.filter(p => typeof p === 'object');
    return acc + arr.reduce((sum, ans, oI) => sum + (ans === opts[oI].answer ? 1 : 0), 0);
  }, 0);
  const fgwoMax = FILL_GAP_WITH_OPTIONS_QUESTIONS.reduce((a, q) => a + q.parts.filter(p => typeof p === 'object').length, 0);


  const TOTAL_CORRECT = score + gapScore + matchScore + fgwoScore;
  const TOTAL_MAX = SENTENCES.length + FILL_GAP_QUESTIONS.length + MATCH_HALVES_QUESTIONS.length + fgwoMax;
  const ACCURACY = TOTAL_MAX > 0 ? Math.round((TOTAL_CORRECT / TOTAL_MAX) * 100) : 0;


  const accuracyRatio = TOTAL_CORRECT / TOTAL_MAX;

  let RUSSIAN_LEVEL = '';
  if (accuracyRatio < 0.25) RUSSIAN_LEVEL = 'A1';
  else if (accuracyRatio < 0.5) RUSSIAN_LEVEL = 'A2';
  else if (accuracyRatio < 0.9) RUSSIAN_LEVEL = 'B1';
  else RUSSIAN_LEVEL = 'B2';
  function handleGoNextFromFgwo() {
    handleFinalComplete();
  }
  
  function handleGoNext() {
    setStage(1);
    setGapChecked(false);
  }

  function handleGoNextFromGap() {
    setStage(2);
    setMatchChecked(false);
  }

  function handleGoNextFromHalves() {
    setStage(3);
    setFgwoChecked(false);
  }

  function handleDropToBlank(idx, wid) {
    setPlaced((prev) => {
      const next = [...prev];
      if (next[idx]) setBank((b) => [...b, next[idx]]);
      next[idx] = wid;
      return next;
    });
    setBank((b) => b.filter((id) => id !== wid));
    setSelectedWord(null);
  }

  function handleDropToBank(wid) {
    setPlaced((prev) => {
      const next = prev.map((v) => (v === wid ? null : v));
      return next;
    });
    setBank((b) => (b.includes(wid) ? b : [...b, wid]));
    setSelectedWord(null);
  }

  function onDragStart(e, wid) {
    e.dataTransfer.setData("text/plain", wid);
    e.dataTransfer.effectAllowed = "move";
  }

  function onBlankDrop(e, idx) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    if (!bank.includes(wid)) {
      const fromIdx = placed.findIndex((p) => p === wid);
      if (fromIdx !== -1) {
        setPlaced((prev) => {
          const next = [...prev];
          const tmp = next[idx];
          next[idx] = wid;
          next[fromIdx] = tmp || null;
          return next;
        });
        return;
      }
    }
    handleDropToBlank(idx, wid);
  }

  function onBankDrop(e) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    handleDropToBank(wid);
  }

  function handleGapInput(idx, value) {
    setGapAnswers((prev) => {
      const next = [...prev];
      next[idx] = value;
      return next;
    });
  }

  function handleGapCheck() {
    setGapChecked(true);
  }

  function handleGapReset() {
    setGapAnswers(Array(FILL_GAP_QUESTIONS.length).fill(""));
    setGapChecked(false);
  }

  function handleMatchSelectLeft(lidx) {
    setMatchSelectedLeft(lidx);
  }

  function handleMatchSelectRight(ridx) {
    if (matchSelectedLeft === null) return;
    setMatchPairs(prev => {
      const next = [...prev];
      next[matchSelectedLeft] = ridx;
      return next;
    });
    setMatchSelectedLeft(null);
  }

  function handleMatchCheck() {
    setMatchChecked(true);
  }

  function handleMatchReset() {
    setMatchPairs(Array(MATCH_HALVES_QUESTIONS.length).fill(null));
    setMatchChecked(false);
    setMatchSelectedLeft(null);
  }

  function handleFgwoSelect(qIdx, optIdx, value) {
    setFgwoAnswers(prev => {
      const next = prev.map((arr, i) => arr.slice());
      next[qIdx][optIdx] = value;
      return next;
    });
  }

  function handleFgwoCheck() {
    setFgwoChecked(true);
  }

  function handleFgwoReset() {
    setFgwoAnswers(FILL_GAP_WITH_OPTIONS_QUESTIONS.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked(false);
  }

  function resetAll() {
    setBank(WORDS.map((w) => w.id));
    setPlaced(Array(SENTENCES.length).fill(null));
    setSelectedWord(null);
    setChecked(false);
  }

  function checkAnswers() {
    setChecked(true);
  }

  function handleWordClick(wid) {
    setSelectedWord((cur) => (cur === wid ? null : wid));
  }

  function handleBlankClick(idx) {
    if (!selectedWord) return;
    handleDropToBlank(idx, selectedWord);
  }

  // Auto-check Stage 0 (drag-and-drop)
  React.useEffect(() => {
    if (stage === 0 && placed.every(p => p !== null)) {
      setChecked(true);
    }
  }, [placed, stage]);

  // Auto-check Stage 1 (fill gaps)
  React.useEffect(() => {
    if (stage === 1 && gapAnswers.every(ans => ans.trim() !== '')) {
      const timer = setTimeout(() => {
        setGapChecked(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [gapAnswers, stage]);

  // Auto-check Stage 2 (match halves)
  React.useEffect(() => {
    if (stage === 2 && matchPairs.every(p => p !== null)) {
      setMatchChecked(true);
    }
  }, [matchPairs, stage]);

  // Auto-check Stage 3 (fill with options)
  React.useEffect(() => {
    if (stage === 3 && fgwoAnswers.every(arr => arr.every(a => a !== ''))) {
      setFgwoChecked(true);
    }
  }, [fgwoAnswers, stage]);

  return (
    <div className="app">
      <header className="brand">
        <div className="logoDot" />
        <span>Тест на уровень русского</span>
      </header>

      <div className="main-content">
        <div className="progress-parent">
          <div className="level-progress-box">
            <div className="lpb-title-group">
              <span className="lpb-level-header">Прогресс теста</span>
              <div className="lpb-level-name">{Math.round((stage / 3) * 100)}%</div>
            </div>
            <div className="lpb-bar-group">
              <div className="lpb-bar-bg">
                <div
                  className="lpb-bar-fill"
                  style={{ width: `${(stage / 3) * 100}%` }}
                />
              </div>
            </div>
            <div className="lpb-stats-row">
              <div className="lpb-stat-acc">
                <span className="lpb-stat-label">Завершено</span>
                <span className="lpb-stat-value">{stage}/4</span>
              </div>
              <div className="lpb-stat-score">
                <span className="lpb-stat-label">Этап</span>
                <span className="lpb-stat-value">{stage + 1}</span>
              </div>
            </div>
          </div>
        </div>

        <main className="card">
          {showResults ? (
            <div className="results-page">
              <div className="results-header">
                <h2 className="title">Результаты теста</h2>
                <p className="results-subtitle">Поздравляем с завершением теста!</p>
              </div>
              
              <div className="results-stats">
                <div className="result-stat-card">
                  <div className="result-stat-label">Правильных ответов</div>
                  <div className="result-stat-value">{TOTAL_CORRECT} / {TOTAL_MAX}</div>
                </div>
                
                <div className="result-stat-card">
                  <div className="result-stat-label">Точность</div>
                  <div className="result-stat-value result-stat-value--accent">{ACCURACY}%</div>
                </div>
                
                <div className="result-stat-card result-stat-card--highlight">
                  <div className="result-stat-label">Ваш уровень</div>
                  <div className="result-stat-value result-stat-value--large">{RUSSIAN_LEVEL}</div>
                </div>
              </div>
              
              <div className="results-breakdown">
                <h3 className="results-breakdown-title">Детальная информация</h3>
                
                <div className="breakdown-item">
                  <span className="breakdown-label">Завершение предложений (перетаскивание)</span>
                  <span className="breakdown-score">{score}/{SENTENCES.length}</span>
                </div>
                
                <div className="breakdown-item">
                  <span className="breakdown-label">Заполнение пропусков (ввод текста)</span>
                  <span className="breakdown-score">{gapScore}/{FILL_GAP_QUESTIONS.length}</span>
                </div>
                
                <div className="breakdown-item">
                  <span className="breakdown-label">Соединение половинок</span>
                  <span className="breakdown-score">{matchScore}/{MATCH_HALVES_QUESTIONS.length}</span>
                </div>
                
                <div className="breakdown-item">
                  <span className="breakdown-label">Выбор правильного варианта</span>
                  <span className="breakdown-score">{fgwoScore}/{fgwoMax}</span>
                </div>
              </div>
              
              <div className="results-message">
                <p>Отличная работа! Мы свяжемся с вами в ближайшее время для обсуждения следующих шагов.</p>
              </div>
              
              <div className="actions">
                <button className="btn" onClick={handleRestartTest}>
                  Пройти тест снова
                </button>
              </div>
            </div>
          ) : (
            <>
              {/* Stage 0: Drag-and-drop */}
              {stage === 0 && (
                <>
                  <div className="header-card">
                    <h2 className="title">Завершите предложения</h2>
                    {checked && (
                      <div className="score" aria-live="polite">Счет: {score} / {SENTENCES.length}</div>
                    )}
                  </div>

                  <div
                    className="bank"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={onBankDrop}
                  >
                    {WORDS.sort((a, b) => a.text.localeCompare(b.text)).map(
                      ({ id, text }) => {
                        const isUsed = placed.includes(id);
                        return (
                          <button
                            key={id}
                            className={
                              "token" +
                              (selectedWord === id ? " token--selected" : "") +
                              (isUsed ? " token--disabled" : "")
                            }
                            draggable={!isUsed}
                            disabled={isUsed}
                            onDragStart={(e) => !isUsed && onDragStart(e, id)}
                            onClick={() => !isUsed && handleWordClick(id)}
                            aria-label={`Answer option: ${text}`}
                          >
                            {text}
                          </button>
                        );
                      }
                    )}
                  </div>

                  <ol className="sentences">
                    {SENTENCES.map((s, idx) => {
                      const wid = placed[idx];
                      const isCorrect = checked && wid && wordById[wid] === s.answer;
                      const isWrong = checked && wid && wordById[wid] !== s.answer;
                      return (
                        <li key={s.id} className="sentenceRow">
                          <span className="before">{s.textParts[0]}</span>

                          <span
                            className={
                              "blank" +
                              (isCorrect ? " blank--correct" : "") +
                              (isWrong ? " blank--wrong" : "") +
                              (!wid ? " blank--empty" : "")
                            }
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => onBlankDrop(e, idx)}
                            onClick={() => handleBlankClick(idx)}
                            role="button"
                            tabIndex={0}
                          >
                            {wid ? (
                              <span
                                className="filledToken"
                                draggable
                                onDragStart={(e) => onDragStart(e, wid)}
                                title="Верните в блок или нажмите × чтобы удалить"
                              >
                                {wordById[wid]}
                                <button
                                  className="remove"
                                  aria-label="Remove"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDropToBank(wid);
                                  }}
                                >
                                  <img src={close} alt="" />
                                </button>
                              </span>
                            ) : (
                              <span className="placeholder"></span>
                            )}
                          </span>

                          <span className="after">{s.textParts[1]}</span>
                        </li>
                      );
                    })}
                  </ol>

                  <div className="actions">
                    <button className="btn btn--ghost" onClick={resetAll}>Сбросить</button>
                    {checked && (
                      <button className="next-button" onClick={handleGoNext}>Далее</button>
                    )}
                  </div>
                </>
              )}

              {/* Stage 1: Fill-the-gap text */}
              {stage === 1 && (
                <>
                  <div className="header-card">
                    <h2 className="title">Завершите предложения (Введите ответы)</h2>
                    {gapChecked && (
                      <div className="score" aria-live="polite">Счет: {gapScore} / {FILL_GAP_QUESTIONS.length}</div>
                    )}
                  </div>

                  <ol className="sentences fillgap">
                    {FILL_GAP_QUESTIONS.map((q, i) => {
                      const ans = gapAnswers[i];
                      const isCorrect = gapChecked && ans.trim().toLowerCase() === q.answer;
                      const isWrong = gapChecked && ans && !isCorrect;
                      return (
                        <li key={i} className="sentenceRow">
                          <span className="before">{q.text[0]}</span>
                          <input
                            className={
                              "gap-input" +
                              (isCorrect ? " gap-input--correct" : "") +
                              (isWrong ? " gap-input--wrong" : "")
                            }
                            type="text"
                            value={ans}
                            disabled={gapChecked}
                            onChange={e => handleGapInput(i, e.target.value)}
                            aria-label={`Напишите ответ`}
                          />
                          <span className="after">{q.text[1]}</span>
                        </li>
                      );
                    })}
                  </ol>

                  <div className="actions">
                    <button className="btn btn--ghost" onClick={handleGapReset}>Сбросить</button>
                    {gapChecked && (
                      <button className="next-button" onClick={handleGoNextFromGap}>Далее</button>
                    )}
                  </div>
                </>
              )}

              {/* Stage 2: Match Halves */}
              {stage === 2 && (
                <>
                  <div className="header-card">
                    <h2 className="title">Соедините половинки предложений</h2>
                    {matchChecked && (
                      <div className="score" aria-live="polite">Счет: {matchScore} / {MATCH_HALVES_QUESTIONS.length}</div>
                    )}
                  </div>

                  <div className="match-halves-grid">
                    <div className="match-column match-column--left">
                      {matchLeftOrder.map((lid, lidx) => {
                        const question = MATCH_HALVES_QUESTIONS.find(q => q.id === lid);
                        const selected = matchSelectedLeft === lidx;
                        const isUsed = matchPairs[lidx] !== null;
                        return (
                          <div
                            key={lid}
                            className={
                              'match-item' +
                              (selected ? ' match-item--selected' : '') +
                              (isUsed ? ' match-item--used' : '') +
                              (matchChecked && isUsed && lid === matchRightOrder[matchPairs[lidx]]
                                ? ' match-item--correct'
                                : matchChecked && isUsed
                                ? ' match-item--wrong'
                                : '')
                            }
                            onClick={() => !isUsed && handleMatchSelectLeft(lidx)}
                            role="button"
                            tabIndex={0}
                            aria-disabled={isUsed}
                          >
                            {question.left}
                          </div>
                        );
                      })}
                    </div>
                    <div className="match-column match-column--right">
                      {matchRightOrder.map((rid, ridx) => {
                        const question = MATCH_HALVES_QUESTIONS.find(q => q.id === rid);
                        const isMatched = matchPairs.includes(ridx);
                        return (
                          <div
                            key={rid}
                            className={'match-item' + (isMatched ? ' match-item--used' : '')}
                            onClick={() => !isMatched && handleMatchSelectRight(ridx)}
                            role="button"
                            tabIndex={0}
                            aria-disabled={isMatched}
                          >
                            {question.right}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="actions">
                    <button className="btn btn--ghost" onClick={handleMatchReset}>Сбросить</button>
                    {matchChecked && (
                      <button className="next-button" onClick={handleGoNextFromHalves}>Далее</button>
                    )}
                  </div>
                </>
              )}

              {/* Stage 3: Fill-Gap-With-Options */}
              {stage === 3 && (
                <>
                  <div className="header-card">
                    <h2 className="title">Завершите предложения</h2>
                    {fgwoChecked && (
                      <div className="score" aria-live="polite">Счет: {fgwoScore} / {fgwoMax}</div>
                    )}
                  </div>

                  <ol className="sentences">
                    {FILL_GAP_WITH_OPTIONS_QUESTIONS.map((q, qIdx) => {
                      let optIdx = 0;
                      return (
                        <li key={qIdx} className="sentenceRow">
                          {q.parts.map((part, i) => {
                            if (typeof part === 'string') return <span key={i}>{part}</span>;
                            const value = fgwoAnswers[qIdx][optIdx];
                            const correct = fgwoChecked && value === part.answer;
                            const wrong = fgwoChecked && value && value !== part.answer;
                            const options = part.options;
                            const selIdx = optIdx;
                            optIdx++;
                            return (
                              <select
                                key={i}
                                className={'gap-select' + (correct ? ' gap-select--correct' : '') + (wrong ? ' gap-select--wrong' : '')}
                                value={value}
                                onChange={e => handleFgwoSelect(qIdx, selIdx, e.target.value)}
                                disabled={fgwoChecked}
                                aria-label='Выберите правильный вариант'
                              >
                                <option value="">---</option>
                                {options.map(opt => (
                                  <option key={opt} value={opt}>{opt}</option>
                                ))}
                              </select>
                            );
                          })}
                        </li>
                      );
                    })}
                  </ol>

                  <div className="actions">
                    <button className="btn btn--ghost" onClick={handleFgwoReset}>Сбросить</button>
                    {fgwoChecked && (
                      <button className="next-button" onClick={handleGoNextFromFgwo}>Завершить тест</button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </main>
      </div>

      {/* Phone Number Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleModalClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleModalClose} disabled={isSubmitting}>
              ×
            </button>
            
            <div className="modal-header">
              <h2>Ваши результаты:</h2>
              <div className="modal-score-summary" style={{ filter: 'blur(3.8px)', userSelect: 'none' }}>
                <div className="modal-score-item">
                  <span className="modal-score-label">Score:</span>
                  <span className="modal-score-value">{TOTAL_CORRECT}/{TOTAL_MAX}</span>
                </div>
                <div className="modal-score-item">
                  <span className="modal-score-label">Accuracy:</span>
                  <span className="modal-score-value">{ACCURACY}%</span>
                </div>
                <div className="modal-score-item">
                  <span className="modal-score-label">Level:</span>
                  <span className="modal-score-value">{RUSSIAN_LEVEL}</span>
                </div>
              </div>
            </div>
            
            <form onSubmit={handlePhoneSubmit} className="modal-form">
              <p className="modal-description">
                Введите ваш номер телефона чтобы узнать свой уровень!
              </p>
              
              <input
                type="tel"
                className="modal-input"
                placeholder="+7 700 700 70 70"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                disabled={isSubmitting}
                required
              />
              
              {submitError && <div className="modal-error">{submitError}</div>}
              
              <button 
                type="submit" 
                className="btn modal-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Отправляется...' : 'Отправить'}
              </button>
            </form>
          </div>
        </div>
      )}

      <footer className="credit">
        <span>© Akcent Academy, 2025</span>
      </footer>
    </div>
  );
}